import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { wireAuthClient } from "./stores/auth";
import "./i18n"; // init i18next

// Branchement client fetch ↔ store auth (avant le premier render).
wireAuthClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
